<template>
  <div class="banner">
    <div class="top" id="topBannerNav" :style="topBannerNavBg">
      <div @click="gohome" class="left">
        <img src="../../assets/logo1.png" alt="" />
      </div>
      <div class="right">
        <div class="tab">
          <span @click="home">首页</span>
          <div v-show="show" class="slider"></div>
        </div>
        <div class="tab2">
          <span @click="production" class="product">产品中心</span>
          <div v-show="show2" class="slider"></div>
          <div class="navdown">
            <span @click="fqd">智能防窃电系统</span>
            <span @click="yccb">远程抄表系统</span>
            <span @click="bms">BMS蓄电池智能监测</span>
            <span @click="hotline">政府热线/政务服务便民热线</span>
            <!-- <span @click="dcdu">基站智能DCDU</span> -->
            <span @click="ebm">蓄电池单体检测模块</span>
            <span @click="ygd">远程节能控制设备</span>
            <span @click="dcdc">蓄电池远程核容系统</span>
            <span @click="wygd">无源室分</span>
          </div>
        </div>
        <div class="tab">
          <span @click="solution">解决方案</span>
          <div v-show="show3" class="slider"></div>
        </div>
        <div class="tab">
          <span @click="application">应用案例</span>
          <div v-show="show4" class="slider"></div>
        </div>
        <div class="tab">
          <span @click="aboutUs">关于我们</span>
          <div v-show="show5" class="slider"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      topBannerNavBg: {
        backgroundColor: "",
      },
    };
  },
  props: [
    "showSlider",
    "fqdSlider",
    "yccbSlider",
    "BMSSlider",
    "hotlineSlider",
    "solutionSlider",
    "exampleSlider",
    'ygdSlider',
    'DCDCSlider',
    'wygdSlider',
  ],
  mounted() {
    //监听scroll滑动事件
    window.addEventListener("scroll", this.handleScroll, true);
    if (this.showSlider) {
      this.show5 = this.showSlider;
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
    }
    if (this.solutionSlider) {
      this.show5 = false;
      this.show = false;
      this.show2 = false;
      this.show3 = this.solutionSlider;
      this.show4 = false;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
    }
    if (this.exampleSlider) {
      this.show5 = false;
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = this.exampleSlider;
      this.show6 = false;
      this.show7 = false;
      this.show8 = false;
    }
    if (this.fqdSlider) {
      this.show = false;
      this.show2 = this.fqdSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.yccbSlider) {
      this.show = false;
      this.show2 = this.yccbSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.BMSSlider) {
      this.show = false;
      this.show2 = this.BMSSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.hotlineSlider) {
      this.show = false;
      this.show2 = this.hotlineSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.ygdSlider) {
      this.show = false;
      this.show2 = this.ygdSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.DCDCSlider) {
      this.show = false;
      this.show2 = this.DCDCSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
    if (this.wygdSlider) {
      this.show = false;
      this.show2 = this.wygdSlider;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    }
  },
  methods: {
    //scroll事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop) {
        this.topBannerNavBg.backgroundColor = "#1e232f"; // scrollTop + 多少根据自己的需求设置
      } else if (scrollTop === 0) {
        this.topBannerNavBg.backgroundColor = "transparent"; // 设置回到顶部时，背景颜色为透明
      }
    },
    //首页点击
    home() {
      this.show = true;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
      this.$router.push("/");
    },
    production() {
      this.show = false;
      this.show2 = true;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
    },
    solution() {
      this.show = false;
      this.show2 = false;
      this.show3 = true;
      this.show4 = false;
      this.show5 = false;
      this.$router.push({ path: "/solution" });
    },
    application() {
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = true;
      this.show5 = false;
      this.$router.push({ path: "/example" });
    },
    aboutUs() {
      console.log(this.show5);
      this.show5 = true;
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.$router.push({ path: "/aboutus" });
    },
    fqd() {
      this.$router.push({ path: "/production/fqd" });
    },
    yccb() {
      this.$router.push({ path: "/production/yccb" });
    },
    bms() {
      this.$router.push({ path: "/production/BMS" });
    },
    hotline() {
      this.$router.push({ path: "/production/hotline" });
    },
    gohome() {
      this.$router.push({ path: "/" });
    },
    dcdu(){
      this.$router.push({ path: "/production/DCDU" });
    },
    ebm(){
      this.$router.push({ path: "/production/EBM" });
    },
    ygd() {
      this.$router.push({ path: "/production/ygd" });
    },
    dcdc() {
      this.$router.push({ path: "/production/dcdc" });
    },
    wygd() {
      this.$router.push({ path: "/production/wygd" });
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  width: 100%;
  height: 100px;
  .top {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border: 1px solid red;
    box-sizing: border-box;
    padding: 0 222px;
    position: fixed;
    top: 0;
    z-index: 10000;
    .left {
      cursor: pointer;
      img {
        width: 231px;
        height: 42px;
      }
    }
    .right {
      width: 60%;
      // height: 85px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tab {
        width: 15%;
        height: 50px;
        // border: 1px solid red;
        text-align: center;
        span {
          font-size: 16px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          // border: 1px solid blue;
        }
        .slider {
          width: 70%;
          margin: 0 auto;
          height: 4px;
          background: #0d75dd;
          opacity: 1;
          // border: 1px solid yellow;
          margin-top: 15px;
        }
      }
      .tab2 {
        width: 15%;
        height: 50px;
        text-align: center;
        position: relative;
        .product {
          font-size: 16px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }
        .slider {
          width: 100%;
          height: 4px;
          background: #0d75dd;
          opacity: 1;
          margin-top: 15px;
        }
        .navdown {
          width: 210px;
          height: 240px;
          // border: 1px solid #cccccc;
          visibility: hidden;
          position: absolute;
          top: 50px;
          display: flex;
          flex-direction: column;
          span {
            width: 100%;
            height: 60px;
            border-bottom: 1px solid #cccccc;
            background: #ffffff;
            font-size: 16px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #2d2f26;
            text-align: center;
            line-height: 60px;
            cursor: pointer;
          }
          span:hover {
            background: #0d75dd;
            color: #ffffff;
          }
        }
      }
      .tab2:hover .navdown {
        visibility: visible;
      }
    }
  }
}
</style>